"use strict";
// [licensed or not] [geo] [domain]
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_KEYS = exports.TEXT_CATEGORIES = void 0;
var TEXT_CATEGORIES;
(function (TEXT_CATEGORIES) {
    TEXT_CATEGORIES["TERMS_OF_USE"] = "terms-of-use";
    TEXT_CATEGORIES["TERMS_AND_CONDITIONS"] = "terms-and-conditions";
    TEXT_CATEGORIES["AML_KYC_POLICY"] = "aml-kyc-policy";
    TEXT_CATEGORIES["AML_POLICY"] = "aml-policy";
    TEXT_CATEGORIES["KYC_POLICY"] = "kyc-policy";
    TEXT_CATEGORIES["BONUS_POLICY"] = "bonus-policy";
    TEXT_CATEGORIES["PAYMENT_POLICY"] = "payment-policy";
    TEXT_CATEGORIES["PRIVACY_POLICY"] = "privacy-policy";
    TEXT_CATEGORIES["RESPONSIBLE_GAMING"] = "responsible-gaming";
    TEXT_CATEGORIES["UNDERAGE_GAMING_POLICY"] = "underage-gaming-policy";
    TEXT_CATEGORIES["LICENSE"] = "license";
    TEXT_CATEGORIES["VIP_LOYALTY"] = "vip-loyalty";
    TEXT_CATEGORIES["SELF_EXCLUSION_POLICY"] = "self-exclusion-policy";
    TEXT_CATEGORIES["META"] = "meta";
    TEXT_CATEGORIES["CONFIGURATION"] = "configuration";
    TEXT_CATEGORIES["PROMOTIONS"] = "promotions";
    TEXT_CATEGORIES["PROMO_BANNERS"] = "promo-banners";
    TEXT_CATEGORIES["PROMO_TESTIMONIALS"] = "promo_testimonials";
    TEXT_CATEGORIES["MAIN_BANNER_SLIDER"] = "main-banner-slider";
})(TEXT_CATEGORIES = exports.TEXT_CATEGORIES || (exports.TEXT_CATEGORIES = {}));
var TEXT_KEYS;
(function (TEXT_KEYS) {
    TEXT_KEYS["AML_KYC_POLICY"] = "AML-KYC-POLICY";
    TEXT_KEYS["KYC_POLICY"] = "KYC-POLICY";
    TEXT_KEYS["AML_POLICY"] = "AML-POLICY";
    TEXT_KEYS["BONUS_POLICY"] = "BONUS-POLICY";
    TEXT_KEYS["PAYMENT_POLICY"] = "PAYMENT-POLICY";
    TEXT_KEYS["PRIVACY_POLICY"] = "PRIVACY-POLICY";
    TEXT_KEYS["RESPONSIBLE_GAMING"] = "RESPONSIBLE-GAMING";
    TEXT_KEYS["UNDERAGE_GAMING_POLICY"] = "UNDERAGE-GAMING-POLICY";
    TEXT_KEYS["SELF_EXCLUSION_POLICY"] = "SELF-EXCLUSION-POLICY";
    TEXT_KEYS["FOOTER_LICENSE"] = "FOOTER-LICENSE";
    TEXT_KEYS["FAQ"] = "FAQ";
    TEXT_KEYS["MAIN"] = "MAIN";
    TEXT_KEYS["GAME"] = "GAME";
    TEXT_KEYS["PROMOTIONS"] = "PROMOTIONS";
    TEXT_KEYS["PAYMENTS"] = "PAYMENTS";
    TEXT_KEYS["VIP"] = "VIP";
    TEXT_KEYS["GAMES"] = "GAMES";
    TEXT_KEYS["PROVIDERS"] = "PROVIDERS";
    TEXT_KEYS["ACCOUNT"] = "ACCOUNT";
    TEXT_KEYS["TERMS_OF_USE"] = "TERMS-OF-USE";
    TEXT_KEYS["TERMS_AND_CONDITIONS"] = "TERMS-AND-CONDITIONS";
    TEXT_KEYS["LOTTERIES"] = "LOTTERIES";
    TEXT_KEYS["TOURNAMENTS"] = "TOURNAMENTS";
    TEXT_KEYS["BY_DOMAIN"] = "BY-DOMAIN";
    TEXT_KEYS["EXCLUSIVE_OFFERS_INBOX"] = "EXCLUSIVE_OFFERS_INBOX";
    TEXT_KEYS["DAILY_CASHBACK"] = "DAILY_CASHBACK";
    TEXT_KEYS["BIRTHDAY_BONUS"] = "BIRTHDAY_BONUS";
    TEXT_KEYS["TRUSTPILOT_CARD"] = "TRUSTPILOT_CARD";
    TEXT_KEYS["CASINOBEE_CARD"] = "CASINOBEE_CARD";
    TEXT_KEYS["CASINO_GURU_CARD"] = "CASINO_GURU_CARD";
    TEXT_KEYS["CASINOBERNIE_CARD"] = "CASINOBERNIE_CARD";
    TEXT_KEYS["SLOT_CATALOG_CARD"] = "SLOT_CATALOG_CARD";
    TEXT_KEYS["CASINOFORMAT_CARD"] = "CASINOFORMAT_CARD";
    TEXT_KEYS["WELCOME_OFFER"] = "WELCOME_OFFER";
    TEXT_KEYS["VIP_BONUS"] = "VIP_BONUS";
    TEXT_KEYS["LOTTERY_BANNER"] = "LOTTERY_BANNER";
    TEXT_KEYS["WHEEL_BANNER"] = "WHEEL_BANNER";
    TEXT_KEYS["LIMITED_OFFER_BANNER"] = "LIMITED_OFFER_BANNER";
    TEXT_KEYS["CATEGORY_BANNER"] = "CATEGORY_BANNER";
    TEXT_KEYS["PAYMENTS_BANNER"] = "PAYMENTS_BANNER";
    TEXT_KEYS["WELCOME_DEPOSIT_BANNER"] = "WELCOME_DEPOSIT_BANNER";
    TEXT_KEYS["WELCOME_DEPOSIT_VIP_BANNER"] = "WELCOME_DEPOSIT_VIP_BANNER";
})(TEXT_KEYS = exports.TEXT_KEYS || (exports.TEXT_KEYS = {}));
